<template>
  <GlobalLayout>
    <div class="group_warp">
      <div class="group-title">群组<span class="groupname" style="color: #383838; margin-left: 3rem"
            >当前群组:{{ nowGroupName }}</span
          ></div>

      <div class="paths">
        <router-link to="/control/allgroup/group"
          >群组列表</router-link
        >
        <router-link to="/control/allgroup/grouptree"
          >群组树</router-link
        >
      </div>
      <hr style="color: #e5e5e5; opacity: 0.2" />
    <keep-alive>
                <router-view></router-view>
            </keep-alive>
    </div>
  </GlobalLayout>
</template>

<script>
import GlobalLayout from "@/components/globalLayout/globalLayout";
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "@/libs/api.request";
import { getToken, formatDate } from "@/libs/util";
export default {
  components: {
    GlobalLayout,
  },
  data() {
    return {
      nowGroupName: "",
    };
  },
  computed: {
    ...mapGetters("user", [
      "isAdmin",
      "isPerson",
      "isCompanyUser",
      "getCompanyCode",
      "getCompanyName",
      "setControlMode",
      "isControlMode",
      "getUserType",
      'getGroup'
    ]),
  },
  mounted() {
      this.nowGroupName=this.getGroup().groupName
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.group_warp{
    padding: 4rem;
    .group-title{
        font-size: 3.6rem;
        font-family: PingFangHK-Semibold, PingFangHK;
        font-weight: 600;
        color: #222222;
    }
    .paths {
        margin: 2.4rem 0;

        a {
            margin-right: 5rem;
            display: inline-block;
            line-height: 3rem;
            color: #222222;
            font-size: 2rem;
            font-family: PingFangHK-Regular, PingFangHK;
            font-weight: 400;

            &.active {
                color: #1960e1;
                font-weight: 600;
            }
        }
    }
}
.groupname{
    font-size: 2.4rem;
}
</style>